import {Col, Modal, Row, Table} from "react-bootstrap";
import {IoMdClose} from "react-icons/io";
import iconCalendar from "../../../images/icon-calendar-solid.svg";
import CustomDatePickerRange from "../../component/ui/DatePickerRange";
import React, {Dispatch, SetStateAction, useContext, useEffect, useRef, useState} from "react";
import {fn_getCurrentDate} from "../../../helper/CmmnHelper";
import {getLoginUser} from "../../../helper/SecurityHelper";
import {Container} from "@mui/material";
import {COMMON_MODAL_STYLE, COMMON_MULTISEL_STRINGS} from "../../../helper/StyleHelper";
import Select from 'react-select'
import {MultiSelect} from "react-multi-select-component";
import axios from "axios";
import {toast} from "react-toastify";
import messageCodeDic from "../../../util/messageCodeDic";
import errorCodeDic from "../../../util/errorCodeDic";
import BMCInput from "../../../components/common/BMCInput";
import BMCTextarea from "../../../components/common/BMCTextarea";
import BMCSelect from "../../../components/common/BMCSelect";
import CustomDatePicker from "../../component/ui/DatePicker";
import BMCDatePicker from "../../../components/common/BMCDatePicker";
import restapi from "../../../helper/restAPIHelper";
import {ProgressContext} from "../../../context/Progress";
import BMCIconButton from "../../../components/common/BMCIconButton";
import IconRemove from "../../../images/icon_remove.png";
import WrkrSrchModal from "../../siteSafetyManagement/modal/WrkrSrchModal";
import BMCFile from "../../../components/common/BMCFile";



interface IProps {
    setModalIsOpen: Dispatch<SetStateAction<boolean>>;
    modalIsOpen: boolean;
    detailData: any;
    siteId: number;
}

const SmrtSftyEqmntRgstModal = (props: IProps) => {

    const prodRef = useRef<any>();
    const currentDate = fn_getCurrentDate();
    const user = getLoginUser();

    const [eduDt, setEduDt] = useState<string>('');
    const [isDatePopupOpen, setIsDatePopupOpen] = useState(false);

    const [data, setData] = useState<any>()
    const [selected, setSelected] = useState([])
    const [eduTimeList, setEduTimeList] = useState<any>([]);
    const fileRef = useRef() as React.MutableRefObject<any>;
    const formRef = React.createRef<HTMLFormElement>();
    const {spinner} = useContext(ProgressContext);
    const [eduPtcptList, setEduPtcptList] = useState<any>([]);
    const [isEduPtcptPopOpen, setIsEduPtcptPopOpen] = useState(false);
    const [atchFileList, setAtchFileList] = useState<any>([]);


    const fn_setFormData = (e: any) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    function afterOpenModal() {
        if (!props.detailData) {
            console.log('props.siteId: ', props.siteId);
            setData({siteId: props.siteId, cmpnySeq: user.blngCmpnySeq})
            setEduDt('')
            setSelected([])
            setEduPtcptList([]);
            setAtchFileList([]);
            // 상세
        } else {
            setData(props.detailData);
            const atchFileId = props.detailData.atchFileId;

            if (atchFileId) {
                restapi.retrieveAttachInfoList({attachSeq: atchFileId}).then((rsltData: any) => {
                    console.log('rsltData: ', rsltData);
                    setAtchFileList([].concat(rsltData))
                })
            } else {
                setAtchFileList([]);
            }
        }
        fn_genEduTime();
    }

    function fn_closeModal() {
        props.setModalIsOpen(false);
    }

    const fn_datePopupOpen = () => {
        setIsDatePopupOpen(!isDatePopupOpen);
    };

    const submit = (e: any) => {
        e.preventDefault()

    }

    const fn_registData = () => {

        if (!data) {
            toast.warn('데이터를 입력해 주십시오.')
            return;
        }

        if (!data.cmpnySeq) {
            toast.warn('업체를 선택해 주십시오.')
            return;
        }

        if(!data.eqmntGb) {
            toast.warn('장비 구분값을 선택해 주십시오.');
            return;
        }

        if (!data.prdctNm) {
            toast.warn('제품명을 입력해 주십시오.');
            return;
        }

        if (!data.cntnts) {
            toast.warn('내용을 입력해 주십시오.');
            return;
        }

        let param = data;
        param.rgstrSeq = user.userSeq;
        param.updtrSeq = user.userSeq;

        // @ts-ignore
        var formData: any = new FormData(formRef.current);
        console.log('atchFileList: ', atchFileList);

        if(atchFileList.length > 0){
            for(var i = 0; i<atchFileList.length; i++){
                formData.append('atchFileList',atchFileList[i]);
            }
        }

        console.log('form get: ', formData.get('atchFileList'))

        if(!window.confirm('저장 하시겠습니까?')){
            return;
        }

        formData.set('jsonData', new Blob([JSON.stringify(param)], {type: "application/json"}))
        spinner.start();
        axios.post('/admin/api/smrtSftyEqmnt/saveSmrtSftyEqmntData', formData).then((result) => {

            if (result.data > 0) {
                toast.success(messageCodeDic['001'])
                props.setModalIsOpen(false);
            } else {
                toast.error(errorCodeDic['003']);
            }
        }).catch(error => {
            toast.error(errorCodeDic['003']);
            console.log('error: ', error);
        })
            .finally(() => {
                spinner.stop();
            });

    }

    const fn_genEduTime = () => {

        let date = new Date(2023, 0, 1);
        let timeArr = ['00:00']
        let hr;
        let mi;

        for (var i = 0; i < 47; i++) {
            date.setMinutes(date.getMinutes() + 30);
            hr = date.getHours() + '';
            mi = date.getMinutes() + '';
            if (hr.length == 1) {
                hr = '0' + hr;
            }
            if (mi.length == 1) {
                mi = '0' + mi;
            }
            timeArr.push(hr + ':' + mi);
        }

        setEduTimeList(timeArr);


    }


    return (
        <div>
            <Modal
                className="bmc-modal" size="xl"
                show={props.modalIsOpen}
                onShow={afterOpenModal}
                onHide={fn_closeModal}
            >
                <Modal.Header>
                    <div className="d-flex justify-content-between align-items-center w-100 bmc-font-SD">
                        스마트안전장비 등록/수정
                        <IoMdClose className='hover:cursor-pointer' onClick={fn_closeModal}/>
                    </div>
                </Modal.Header>

                <Modal.Body className="px-4">
                    <form name={'form'} ref={formRef} encType="multipart/form-data" method={"post"}
                          onSubmit={submit}>
                        <div className="bmc-modal-div">
                            <div className="div-header">
                                교육정보
                            </div>
                            <div className="div-body px-3">
                                <Table className="my-2 align-middle">
                                    <tbody>
                                    <tr className="border-top align-middle">
                                        <th className="bmc-bg-th" style={{width: '15%'}}>현장</th>
                                        <td style={{width: '35%'}}>
                                            <BMCSelect initOptionGb={'none'} disabled={true} codeGb={'site'}
                                                      onChange={fn_setFormData} className={'form-control w-100'}
                                                      value={data?.siteId}></BMCSelect>
                                        </td>
                                        <th className="bmc-bg-th" style={{width: '15%'}}>업체</th>
                                        <td style={{width: '35%'}} ref={prodRef}>
                                            <BMCSelect initOptionGb={'sel'} name={'cmpnySeq'}
                                                       selParam={{
                                                           siteId: props.siteId,
                                                           cmpnySeq: user.authCode === 'siteMstr' ? null : user.blngCmpnySeq
                                                       }}
                                                       codeGb={'siteCmpny'}
                                                       className="bmc-form select w-100"
                                                       disabled={false}
                                                       onChange={(e) => {
                                                           fn_setFormData(e);
                                                       }}
                                                       value={data?.cmpnySeq}></BMCSelect>
                                        </td>
                                    </tr>
                                    <tr className="border-top align-middle">
                                        <th className="bmc-bg-th" style={{width: '15%'}}>구분</th>
                                        <td style={{width: '35%'}}>
                                            <BMCSelect initOptionGb={'sel'} name={'eqmntGb'} codeGb={'cmmn'} codeGrpId={'E003'} className={"min-w-[100px]"}
                                                       onChange={fn_setFormData}
                                                       value={data?.eqmntGb}></BMCSelect>
                                        </td>
                                        <th className="bmc-bg-th" style={{width: '15%'}}>제품명</th>
                                        <td style={{width: '35%'}}>
                                            <BMCInput type="text" className="form-control" name={'prdctNm'}
                                                      onChange={fn_setFormData} value={data?.prdctNm}/>
                                        </td>

                                    </tr>
                                    <tr className="border-top align-middle">
                                        <th className="bmc-bg-th" style={{width: '15%'}}>내용</th>
                                        <td style={{width: '85%'}} colSpan={3}>
                                            <BMCTextarea rows={5} onChange={fn_setFormData} name={'cntnts'}
                                                         value={data?.cntnts}
                                                         className={"form-control"}
                                                         placeholder='내용을 입력해주세요.'/>
                                        </td>
                                    </tr>

                                    <tr className="border-top align-middle">
                                        <th className="bmc-bg-th" style={{width: '15%'}}>첨부파일</th>
                                        <td style={{width: '85%'}} colSpan={3}>
                                            <BMCFile fileName={'files'} fileList={atchFileList}
                                                     setFileList={setAtchFileList} disabled={false}></BMCFile>
                                        </td>
                                    </tr>

                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        <div className="bmc-modal-div">
                            <div className="div-header">
                                작성정보
                            </div>
                            <div className="div-body px-3">
                                <Table className="my-2 align-middle">
                                    <tbody>
                                    <tr className="border-top align-middle">
                                        <th className="bmc-bg-th" style={{width: '15%'}}>작성일</th>
                                        <td style={{width: '35%'}}>
                                            <input value={data?.rgstDt || currentDate}
                                                   className={"form-control"}
                                                   disabled={true}/>
                                        </td>
                                        <th className="bmc-bg-th" style={{width: '15%'}}>작성자</th>
                                        <td style={{width: '35%'}}>
                                            <input className={"form-control"}
                                                   value={data?.rgstrNm || user.userName} disabled={true}/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </Table>


                            </div>

                        </div>


                    </form>
                </Modal.Body>

                <Modal.Footer className="py-2">
                    <div className='flex justify-center w-100'>
                        <button
                            className='bmc-btn pill l white me-3'
                            onClick={fn_closeModal}>닫기
                        </button>
                        <button
                            className='bmc-btn pill p' onClick={fn_registData}>저장
                        </button>
                    </div>
                </Modal.Footer>

            </Modal>
        </div>
    )
}

export default SmrtSftyEqmntRgstModal;

